<template>
  <div class="talent-page">
    <!-- 轮播图部分 -->
    <HomeCarousel 
      :carouselData="banners"
      :interval="5000"
    />
    
    <div class="talent-container">
      <!-- 人才全生命周期服务 -->
      <section class="talent-section" data-aos="fade-up">
        <h2>{{ $t('talentPage.lifecycle') }}</h2>
        <div class="content" v-html="talentInfo.lifecycle"></div>
      </section>

      <!-- 人才服务案例 -->
      <section class="talent-section" data-aos="fade-up">
        <h2>{{ $t('talentPage.cases') }}</h2>
        <div class="content" v-html="talentInfo.cases"></div>
      </section>

      <!-- 人才服务标准 -->
      <section class="talent-section" data-aos="fade-up">
        <h2>{{ $t('talentPage.standard') }}</h2>
        <div class="content" v-html="talentInfo.standard"></div>
      </section>
    </div>
  </div>
</template>

<script>
import HomeCarousel from '@/components/Carousel.vue'
import { getBannerList } from '@/api/home'
import { getTalentInfo } from '@/api/talent'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'TalentView',
  components: {
    HomeCarousel
  },
  data() {
    return {
      banners: [],
      talentInfo: {
        lifecycle: '',  // type: 1
        cases: '',      // type: 2
        standard: ''    // type: 3
      }
    }
  },
  created() {
    this.getBanners()
    this.getTalentInfo()
  },
  mounted() {
    // 初始化 AOS
    AOS.init({
      duration: 1000,    // 动画持续时间
      once: true,        // 动画是否只执行一次
      offset: 100,       // 触发动画的位置
      easing: 'ease-in-out-cubic' // 动画曲线
    })
  },
  methods: {
    async getBanners() {
      try {
        const res = await getBannerList()
        this.banners = res.data.filter(item => item.type === 3)
      } catch (error) {
        console.error('获取轮播图数据失败:', error)
      }
    },
    async getTalentInfo() {
      try {
        const res = await getTalentInfo()
        // 处理返回的数组数据
        res.data.forEach(item => {
          switch(item.type) {
            case 1:
              this.talentInfo.lifecycle = item.description
              break
            case 2:
              this.talentInfo.cases = item.description
              break
            case 3:
              this.talentInfo.standard = item.description
              break
          }
        })
      } catch (error) {
        console.error('获取人才服务信息失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.talent-page {
  min-height: 100vh;
  background: #F6F7F9;
}

.talent-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.talent-section {
  border-radius: 12px;
  padding: 40px;
  margin-bottom: 40px;
  max-height: 900px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.talent-section h2 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 30px;
  color: #484848;
  line-height: 42px;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
  display: inline-block;
}

.talent-section h2::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: #3379F2;
  transition: width 0.3s ease-in-out;
}

.talent-section:hover h2::after {
  width: 100%;
}

/* 富文本内容样式 */
.content {
  /* color: #484848; */
}

.content :deep(p) {
  margin-bottom: 16px;
  line-height: 1.8;
  font-size: 16px;
}

.content :deep(img) {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
  transition: all 0.3s ease-in-out;
}

.content :deep(img:hover) {
  transform: scale(1.02);
}

.content :deep(h1),
.content :deep(h2),
.content :deep(h3),
.content :deep(h4),
.content :deep(h5),
.content :deep(h6) {
  margin: 20px 0;
  font-weight: bold;
}

.content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.content :deep(th),
.content :deep(td) {
  border: 1px solid #ddd;
  padding: 8px;
}

.content :deep(ul),
.content :deep(ol) {
  padding-left: 20px;
  margin: 16px 0;
}

.content :deep(li) {
  margin-bottom: 8px;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .talent-container {
    padding: 20px;
  }
  
  .talent-section {
    padding: 20px;
    margin-bottom: 20px;
  }
  
  .talent-section h2 {
    font-size: 24px;
    margin-bottom: 30px;
  }
}
</style> 